// extracted by mini-css-extract-plugin
export default {"action":"HardwareDetailsHeader_action__Nobe4"};